import { CreateFormProps } from 'components/create-form'

export const CREATE_FORM_MODAL_ID = 'create-form-modal'

export type OpenFormModalProps = Omit<CreateFormProps, 'onSuccess'>
